import { SheetDto } from './';

export class WorkbookDto {
    workbookId :number;
    fileName :string;
    fullPath :string;
    presetId: string;
    sheets :SheetDto[]=[];
}
